var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.461.269H.538A.538.538 0 000 .807v9.154a1.077 1.077 0 001.077 1.077h11.846A1.077 1.077 0 0014 9.96V.807a.538.538 0 00-.539-.538zm-1.384 1.077L7 6 1.923 1.346h10.154zm.846 8.615H1.077v-7.93l5.559 5.096a.538.538 0 00.728 0l5.56-5.095V9.96z"
  })));
}
export default SvgEmail;